"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialIcon = void 0;
const react_1 = __importStar(require("react"));
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const IconQR_atom_1 = require("./IconQR.atom");
const styled_components_1 = __importDefault(require("styled-components"));
const epic_games_nav_shared_2 = require("epic-games-nav-shared");
const Styled = styled_components_1.default.a `
    width: 40px;
    height: 40px;
    display: inline-block;
    padding: 10px 6px 8px;
    text-decoration: none;

    ${(p) => p.theme.breakpoints.up('sm')} {
        margin-right: 6px;
    }

    && {
        color: ${(p) => p.theme.palette.text.secondary || p.theme.palette.text.primary};
    }

    i {
        font-size: 1.75em;
    }
`;
const SocialIcon = ({ id, href, qrCode }) => {
    const onClick = (0, react_1.useCallback)((e) => {
        if (e.button && e.button > 0)
            return;
        if (qrCode) {
            e.preventDefault();
        }
    }, [qrCode]);
    const getMessage = (0, epic_games_nav_shared_1.useLocalization)();
    if (!id)
        return null;
    const label = getMessage('epic.footer.social.link.label', [id]);
    if (qrCode) {
        return react_1.default.createElement(IconQR_atom_1.IconQR, { id: id, qrCode: qrCode });
    }
    return (react_1.default.createElement(Styled, { id: id, className: "social-icon", "aria-label": label, href: href, onClick: onClick, onMouseDown: epic_games_nav_shared_2.stopFocusOnClick, target: "_blank", rel: "noopener noreferrer" },
        react_1.default.createElement("i", { className: `eg-footer-icon-${id}` }, "\u00A0")));
};
exports.SocialIcon = SocialIcon;
//# sourceMappingURL=SocialIcon.atom.js.map